module.exports = __webpack_public_path__ + "img/bannerMob.bcabdd27.png";